import { Component, OnInit } from '@angular/core';
import { PolicyDetailsStepFormHandlerComponent } from './policy-details-step-form.handler';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { Location } from '@angular/common';

@Component({
  selector: 'sym-policy-details-step-form',
  templateUrl: './policy-details-step-form.component.html',
  styleUrls: ['./policy-details-step-form.component.scss'],
})
export class PolicyDetailsStepFormComponent extends PolicyDetailsStepFormHandlerComponent implements OnInit {
  policyNum: string;
  constructor(
    service: PolicyDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  async ngOnInit() {
    await this.getCompanyFacet();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  protected postLoadCompanyFacets() {
    super.ngOnInit();
  }

  async getCompanyFacet() {
    await this.loadCompanyFacets();
  }
}
